import React from "react";
import { FormInputProps, FormTextareaProps } from "@/types";
import { cn } from "@/lib/utils";

export function FormInput({ className, ...props }: FormInputProps) {
    return (
        <input
            {...props}
            className={cn(
                "w-full bg-transparent border border-white px-4 py-3.5 text-sm text-white placeholder:text-cream focus:outline-none focus:border-brand-green focus:ring-1 focus:ring-brand-green disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-poppins",
                className
            )}
        />
    );
}

export function FormTextarea({ className, rows = 4, ...props }: FormTextareaProps) {
    return (
        <textarea
            rows={rows}
            {...props}
            className={cn(
                "w-full bg-transparent border border-white px-4 py-3.5 text-sm text-white placeholder:text-cream focus:outline-none focus:border-brand-green focus:ring-1 focus:ring-brand-green disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-poppins resize-y",
                className
            )}
        />
    );
}
